import React, { useCallback, useMemo } from "react";

import { Editor } from "slate";
import { useSlate } from "slate-react";

import insertLink from "../../../../util/insertLink";

import LinkEditModal from "./LinkEditModal";

interface Props {
  defaultText?: string;
  onHide?: () => void;
}

const CreateLink: React.FC<Props> = ({ defaultText, onHide }) => {
  const editor = useSlate();

  const isMultiLine = useMemo(() => {
    return !!(defaultText && editor.selection?.anchor.path[0] !== editor.selection?.focus.path[0]);
  }, [defaultText, editor.selection]);

  const handleOk = useCallback(
    (name: string, url: string) => {
      insertLink(editor, url, name);
      onHide?.();
    },
    [onHide, editor]
  );

  return (
    <LinkEditModal
      defaultText={editor.selection ? Editor.string(editor, editor.selection) : ""}
      onConfirm={handleOk}
      onHide={onHide}
      textDisabled={isMultiLine}
    />
  );
};

export default CreateLink;
